import React from "react"
import Link from "gatsby-link"
import SEO from '../components/SEO'
import SVGInline from 'react-svg-inline'
import * as PropTypes from "prop-types"

import '../../css/main.less'

import logo from "../../static/img/logo-nicad.svg"

const propTypes = {
  children: PropTypes.func.isRequired,
};

class DefaultLayout extends React.Component {
  constructor() {
    super();
    this.state = {mobile: false};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    if (document.documentElement.clientWidth < 1024) {
      this.setState({mobile: !this.state.mobile});
      if (this.state.mobile) {
        document.body.style.overflow = 'initial';
      } else {
        document.body.style.overflow = 'hidden';
      }
    }
  }

  render() {
    let showMobile = this.state.mobile ? 'with-nav' : '';
    const pageSEO = {
      title: "Administrare imobile Bucuresti - Nicad Admin Imob",
      description: "Oferim servicii premium de administrare Imobile in Bucuresti. Management de inalta calitate adaptat cerintelor dumneavoastra si necesitatilor imobilului in care locuiti.",
      path: ""
    };
    return (
      <div className={showMobile}>
        <SEO pageSEO={pageSEO} />

        <div className="o-page__container">
          <div className="o-page">


            <header className="c-header" role="banner">
              <div className="o-container o-container--large">
                <div className="c-header__nav">
                  <div className="c-header__logo">
                    <Link to="/" className="c-logo">
                      <img src={logo} alt="Logo Protectia-muncii.org"/>
                    </Link>
                  </div>
                  <nav className="c-nav">
                    <ul className="c-menu">
                      <li className="c-menu__item"><Link activeClassName="active" onClick={this.handleClick} to="/servicii/">Servicii</Link></li>
                      <li className="c-menu__item"><Link activeClassName="active" onClick={this.handleClick} to="/preturi/">Preturi</Link></li>
                      <li className="c-menu__item"><Link activeClassName="active" onClick={this.handleClick} to="/legislatie/">Legislatie</Link></li>
                      <li className="c-menu__item"><Link activeClassName="active" onClick={this.handleClick} to="/articole/">Articole</Link></li>
                      <li className="c-menu__item"><Link activeClassName="active" onClick={this.handleClick} to="/contact/">Contact</Link></li>
                      <li className="c-menu__item c-menu__item-ph" style={{marginBottom: '2px'}}>
                        <a onClick={this.handleClick} href="tel:+40722623037" className="c-menu__item-ph-button">
                          <SVGInline
                              className="c-menu__item-phone-icon"
                              svg={`
                                <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="phoneiconmobile" fill="#3A88ED">
                                      <path d="M20,14.92 L20,17.92 C20.0022858,18.4831451 19.767048,19.0211584 19.3520779,19.4018649 C18.9371078,19.7825714 18.3808639,19.9706881 17.82,19.92 C14.7428339,19.5856408 11.7869992,18.5341445 9.19,16.85 C6.77382812,15.3146639 4.72533615,13.2661719 3.19,10.85 C1.49997806,8.24120398 0.448243002,5.27099456 0.12,2.18 C0.0694732103,1.62087233 0.256272008,1.06625242 0.63476578,0.651621056 C1.01325955,0.236989688 1.54859424,0.000528690239 2.11,8.93924691e-17 L5.11,8.93924691e-17 C6.11386406,-0.00988015716 6.96950085,0.725967482 7.11,1.72 C7.23662301,2.68006645 7.47144946,3.62272688 7.81,4.53 C8.084735,5.26087503 7.90901507,6.08480626 7.36,6.64 L6.09,7.91 C7.51355547,10.4135458 9.58645417,12.4864445 12.09,13.91 L13.36,12.64 C13.9151937,12.0909849 14.739125,11.915265 15.47,12.19 C16.3772731,12.5285505 17.3199335,12.763377 18.28,12.89 C19.2855627,13.0318603 20.02519,13.9047926 20,14.92 Z" id="Shape"></path>
                                    </g>
                                  </g>
                                </svg>
                          `}/>
                          0722 623 037
                        </a>
                      </li>
                      <li className="c-menu__item c-menu__item-ph">
                        <a onClick={this.handleClick} href="tel:+0757484308" className="c-menu__item-ph-button">
                          <SVGInline
                              className="c-menu__item-phone-icon"
                              svg={`
                                <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="phoneiconmobile" fill="#3A88ED">
                                      <path d="M20,14.92 L20,17.92 C20.0022858,18.4831451 19.767048,19.0211584 19.3520779,19.4018649 C18.9371078,19.7825714 18.3808639,19.9706881 17.82,19.92 C14.7428339,19.5856408 11.7869992,18.5341445 9.19,16.85 C6.77382812,15.3146639 4.72533615,13.2661719 3.19,10.85 C1.49997806,8.24120398 0.448243002,5.27099456 0.12,2.18 C0.0694732103,1.62087233 0.256272008,1.06625242 0.63476578,0.651621056 C1.01325955,0.236989688 1.54859424,0.000528690239 2.11,8.93924691e-17 L5.11,8.93924691e-17 C6.11386406,-0.00988015716 6.96950085,0.725967482 7.11,1.72 C7.23662301,2.68006645 7.47144946,3.62272688 7.81,4.53 C8.084735,5.26087503 7.90901507,6.08480626 7.36,6.64 L6.09,7.91 C7.51355547,10.4135458 9.58645417,12.4864445 12.09,13.91 L13.36,12.64 C13.9151937,12.0909849 14.739125,11.915265 15.47,12.19 C16.3772731,12.5285505 17.3199335,12.763377 18.28,12.89 C19.2855627,13.0318603 20.02519,13.9047926 20,14.92 Z" id="Shape"></path>
                                    </g>
                                  </g>
                                </svg>
                          `}/>
                          0757 484 308
                        </a>
                      </li>
                    </ul>
                  </nav>

                  <a onClick={this.handleClick} href="tel:+0722623037" className="c-button c-button--ghost c-menu__item-phone">
                    <SVGInline
                      className="c-menu__item-phone-icon"
                      svg={`
                        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="phoneicon" fill="#3A88ED">
                              <path d="M20,14.92 L20,17.92 C20.0022858,18.4831451 19.767048,19.0211584 19.3520779,19.4018649 C18.9371078,19.7825714 18.3808639,19.9706881 17.82,19.92 C14.7428339,19.5856408 11.7869992,18.5341445 9.19,16.85 C6.77382812,15.3146639 4.72533615,13.2661719 3.19,10.85 C1.49997806,8.24120398 0.448243002,5.27099456 0.12,2.18 C0.0694732103,1.62087233 0.256272008,1.06625242 0.63476578,0.651621056 C1.01325955,0.236989688 1.54859424,0.000528690239 2.11,8.93924691e-17 L5.11,8.93924691e-17 C6.11386406,-0.00988015716 6.96950085,0.725967482 7.11,1.72 C7.23662301,2.68006645 7.47144946,3.62272688 7.81,4.53 C8.084735,5.26087503 7.90901507,6.08480626 7.36,6.64 L6.09,7.91 C7.51355547,10.4135458 9.58645417,12.4864445 12.09,13.91 L13.36,12.64 C13.9151937,12.0909849 14.739125,11.915265 15.47,12.19 C16.3772731,12.5285505 17.3199335,12.763377 18.28,12.89 C19.2855627,13.0318603 20.02519,13.9047926 20,14.92 Z" id="Shape"></path>
                            </g>
                          </g>
                        </svg>
                        `}/>
                    0722 623 037<span className="separator"></span>0757 484 308
                  </a>

                  <a className="c-menu__mobile-button" onClick={this.handleClick}>
                    <div className="c-menu__mobile-button-bar"></div>
                  </a>
                </div>
              </div>
            </header>

            {this.props.children()}

            <footer className="c-footer">
              <div className="o-container o-container--large c-footer__container">
                <div className="o-layout o-layout--gutter-30 c-footer__layout">
                  <div className="o-layout__item o-layout__item--auto-size">
                    <h4 className="c-footer__title">Servicii administrare imobile</h4>

                    <div className="o-layout o-layout--gutter-30 c-footer__services">
                      <div className="o-layout__item o-layout__item--auto-size">
                        <ul className="o-list-bare o-list-05 u-mb-0">
                          <li className="o-list-bare__item"><Link className="c-link-simple" to="/servicii/infiintare-asociatie-proprietari/">Servicii infiintare asociatii de proprietari</Link></li>
                          <li className="o-list-bare__item"><Link className="c-link-simple" to="/servicii/management-proiect/">Servicii de management de proiect</Link></li>
                          <li className="o-list-bare__item"><Link className="c-link-simple" to="/servicii/administrare-tehnica/">Servicii administrare tehnica</Link></li>
                        </ul>
                      </div>
                      <div className="o-layout__item o-layout__item--auto-size">
                        <ul className="o-list-bare o-list-05 u-mb-0">
                          {/*<Link className="c-link-simple" to="/servicii/asistenta-ssm-si-psi/">Asistenta SSM si SU/PSI</Link>*/}
                          <li className="o-list-bare__item"><Link className="c-link-simple" to="/servicii/administrare-financiara/">Servicii financiar-contabile</Link></li>
                          <li className="o-list-bare__item"><Link className="c-link-simple" to="/servicii/cenzorat/">Servicii de cenzorat</Link></li>
                          <li className="o-list-bare__item"><Link className="c-link-simple" to="/servicii/plata-numerar/">Servicii plata numerar</Link></li>
                        </ul>
                      </div>
                    </div>

                  </div>

                  <div className="o-layout__item o-layout__item--auto-size">
                    <div className="c-footer__copy">
                      <h4 className="c-footer__title">Contact</h4>
                      <ul className="o-list-bare o-list-05 u-mb-0">
                        <li className="o-list-bare__item">
                          <a className="c-link-simple" href="tel:+40722623037">0722 623 037</a>
                        </li>
                        <li className="o-list-bare__item">
                          <a className="c-link-simple" href="mailto:nicad.imob@gmail.com">nicad.imob@gmail.com</a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="o-layout__item o-layout__item--auto-size">
                    <div className="c-footer__copy">
                      <h4 className="c-footer__title">Parteneri</h4>
                      <ul className="o-list-bare o-list-05 u-mb-0">
                        <li className="o-list-bare__item">
                          <a className="c-link-simple" href="https://protectia-muncii.org/" target="_blank" rel="noopener">Partener protectia muncii</a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="o-layout__item o-layout__item--auto-size">
                    <SVGInline
                      className=""
                      svg={`
                        <svg width="103px" height="56px" viewBox="0 0 103 56" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->
                          <desc>Created with Sketch.</desc>
                          <defs></defs>
                          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Desktop-HD-Copy-6" transform="translate(-1297.000000, -3707.000000)">
                              <g id="Group-2-Copy" transform="translate(1297.000000, 3707.000000)">
                                <path d="M44.9306215,20.7369851 C46.7733864,21.2003988 46,17.6960211 46,16 C46,9.92486775 41.0751322,5 35,5 C28.9248678,5 24,9.92486775 24,16 C24,16.9412444 23.1114501,18.8847282 24.3406193,18.7268603 C30,18 42,20 44.9306215,20.7369851 Z" id="Oval-2" fill="#DDE3EC"></path>
                                <g id="Group-Copy-2" transform="translate(42.000000, 0.000000)">
                                  <polygon id="Path-13" fill="#CCD3DD" points="8 0 16 3 16 25 8 22"></polygon>
                                  <polygon id="Path-13-Copy" fill="#9CA7B6" points="0 3 8 0 8 22 0 19"></polygon>
                                </g>
                                <g id="Group-Copy" transform="translate(54.000000, 4.000000)">
                                  <polygon id="Path-13" fill="#CCD3DD" points="8 0 16 3 16 24 8 22"></polygon>
                                  <polygon id="Path-13-Copy" fill="#9CA7B6" points="0 3 8 0 8 22 0 20"></polygon>
                                </g>
                                <g id="Group" transform="translate(66.000000, 8.000000)">
                                  <polygon id="Path-13" fill="#CCD3DD" points="8 0 16 3 16 20 8 19"></polygon>
                                  <polygon id="Path-13-Copy" fill="#9CA7B6" points="0 3 8 0 8 20 0 18"></polygon>
                                </g>
                                <text id="Nicad-Admin-Imob" font-family="ProximaNova-Bold, Proxima Nova" font-size="12" font-weight="bold" fill="#9CA7B6">
                                  <tspan x="2" y="54.5">Nicad Admin Imob</tspan>
                                </text>
                                <path d="M0,38 C-3.57353036e-15,35.851804 5,23 26,23 C47,23 68,35 83,34 C93,33.3333333 99.6666667,29.3333333 103,22 C99,33.3333333 92.3333333,39 83,39 C61,39 46,29 26,28 C1.34548208,26.7672741 2.14411822e-15,39.351804 0,38 Z" id="Path-16" fill="#CCD3DD"></path>
                                <path d="M8,24 C8,23 15,16 30,16 C45,16 62.7924528,26 80,26 C91.4716981,26 99.1383648,22.3333333 103,15 C99.6666667,25.6666667 92,31 80,31 C62,31 44.3807494,20.4556187 32,20 C9.35849057,19.1667795 8,25.1263509 8,24 Z" id="Path-16-Copy" fill="#9CA7B6"></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                      `}/>
                  </div>

                </div>
              </div>
            </footer>

            <div className="o-page__overlay" onClick={this.handleClick}></div>
          </div>
        </div>
      </div>
    )
  }
}

DefaultLayout.propTypes = propTypes

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/layouts/index.js